import ImageClass from "../../src/shell/Image";
import { jump } from "../../src/shell/jump";
import Question from "../../src/shell/Questions";
import { images } from "./images";

import { mc } from "../characters/MC";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { ann } from "../characters/Ann";
import { isAgreedToChrisProposal, isAnnGF, isMCCheatedWithMerry } from "../helpers/helpers";
import { chris } from "../characters/Chris";
import { V9MorningTextsDay1After } from "./V9";
import Game from "../../src/shell/Game";

export const V9MorningTextsDay1 = async (): Promise<any> => {
    //ImageClass.setImage(images.TODO_IMAGE)
    mc.think(`I got a couple of texts.`);

    await Phone.showMessagesUI({ name: ann.name }, async () => {
        if (isAnnGF()) {
            Phone.setMessage({ character: ann.character, text: `Good morning 😘\nI have something really important I'd like to talk to you about! Tell me when you are available 🥰`, options: { wait: false } });

        } else {
            Phone.setMessage({ character: ann.character, text: `Hey ${mc.name}, sorry for texting so early...\nI have something really important I'd like to talk to you about... Let me know when you are free please.`, options: { wait: false } });

        }

        Phone.closeMessagesUI();
    });
    mc.think(`I have another text from Chris.`);
    await Phone.showMessagesUI({ name: chris.name }, async () => {
        if (isAgreedToChrisProposal()) {
            Phone.setMessage({ character: chris.character, text: `Hey bro, I have a new hottie I can hook you up with!\nDrop by today when you have the chance, I'll be here all day.`, options: { wait: false } });

        } else {
            Phone.setMessage({ character: chris.character, text: `Hey bro, I could really use your help. I'd appreciate it if you could come by the bar this morning.\nI'll be here all day.`, options: { wait: false } });

        }

        Phone.closeMessagesUI();
    });
    if (isAgreedToChrisProposal()) {
        if (Game.seenScenarios.includes(`V5ChrisRandomGirl`)) {
            mc.talk(`Sweet! A new girl!`);
            mc.think(`I wonder if she's gonna be better than that crazy ass Merry chick.`);
            if (isMCCheatedWithMerry()) {
                if (Question.globalAnswers.v5FuckedMerryAss) {
                    mc.think(`That still didn't stop me from ramming her ass though...`);
                } else if (Question.globalAnswers.v5FuckedMerryAss === false) {
                    mc.think(`That still didn't stop me from letting her suck my cock though...`);
                }
            } else {
                mc.think(`She was too weird. Don't fuck with crazy as they say...`);
            }
        } else {
            mc.think(`Sweet! I hope she's hot!`);
            mc.think(`Time to see if this little agreement we have is really worth it or not.`);
        }
        mc.think(`Anyway, Vanessa was looking for a place to go. This could be perfect.`);

    } else {
        mc.think(`Chris needs my help with the bar? That's kinda weird...`);
        mc.think(`Vanessa was looking for a place to go. We can go together and see what he wants.`);

    }

    return jump(V9MorningTextsDay1After, "V9MorningTextsDay1After");
};
